import React from 'react';
import Main from './Main';
import Clock from './Clock';


function App(){
    return(
        <>
        <Main />
        <Clock />
        </>
    )
}

export default App;
